// ComponentList.js
import React from "react";
import Accueil from "../pages/Accueil";
import InformationsDemandeur from "../pages/InformationsDemandeur";
import InformationsLocal from "../pages/InformationsLocal";
import InformationsProjet from "../pages/InformationsProjet";
import TransmissionCU from "../pages/TransmissionCU";
import Validation from "../pages/Validation";
import Verification from "../pages/Verification";
import { getBase64 } from "../services/getBase64";
import {
  handleChange,
  handleChangeFiles,
  handleChangeMandantConfirm,
  handleChangeMandataireConfirm,
  handleResetFiles,
  handleResetInputFiles,
  handleTrimValue,
  inputFocus,
} from "../utils/inputs";
import { clearSignature, handleSignatureEnd } from "../utils/signature";

const ComponentList = ({
  formData,
  setFormData,
  professional,
  setProfessional,
  professionals,
  setProfessionals,
  proprietaireIndivision,
  setProprietaireIndivision,
  proprietairesIndivision,
  setProprietairesIndivision,
  ville,
  CP,
  page,
  setValidResponse,
  x_id_submit,
  TypeForm,
  files,
  filesTest,
  urlAPI,
  signature,
  setSignature,
  sigRef,
  tooltip,
  setTooltip,
  validResponse,
  setLoading,
  loading,
  toast,
}) => {
  const componentList = [
    <Accueil />,
    <InformationsDemandeur
      formData={formData}
      setFormData={setFormData}
      handleChange={(event) => handleChange(event, setFormData, formData)}
      handleChangeMandataireConfirm={(event) =>
        handleChangeMandataireConfirm(event, setFormData, formData)
      }
      handleChangeMandantConfirm={(event) =>
        handleChangeMandantConfirm(event, formData, setFormData)
      }
      handleTrimValue={(event) => handleTrimValue(event, setFormData)}
      inputFocus={() => inputFocus(page)}
      professional={professional}
      setProfessional={setProfessional}
      professionals={professionals}
      setProfessionals={setProfessionals}
      proprietaireIndivision={proprietaireIndivision}
      setProprietaireIndivision={setProprietaireIndivision}
      proprietairesIndivision={proprietairesIndivision}
      setProprietairesIndivision={setProprietairesIndivision}
      ville={ville}
      CP={CP}
      page={page}
    />,
    <InformationsProjet
      formData={formData}
      setFormData={setFormData}
      handleChange={(event) => handleChange(event, setFormData, formData)}
      handleChangeMandataireConfirm={(event) =>
        handleChangeMandataireConfirm(event, setFormData, formData)
      }
      handleChangeMandantConfirm={(event) =>
        handleChangeMandantConfirm(event, formData, setFormData)
      }
      handleTrimValue={(event) => handleTrimValue(event, setFormData)}
      inputFocus={() => inputFocus(page)}
      professional={professional}
      setProfessional={setProfessional}
      professionals={professionals}
      setProfessionals={setProfessionals}
      proprietaireIndivision={proprietaireIndivision}
      setProprietaireIndivision={setProprietaireIndivision}
      proprietairesIndivision={proprietairesIndivision}
      setProprietairesIndivision={setProprietairesIndivision}
      ville={ville}
      CP={CP}
      page={page}
      setValidResponse={setValidResponse}
      urlAPI={urlAPI}
    />,
    <InformationsLocal
      formData={formData}
      setFormData={setFormData}
      handleChange={(event) => handleChange(event, setFormData, formData)}
      handleChangeMandataireConfirm={(event) =>
        handleChangeMandataireConfirm(event, setFormData, formData)
      }
      handleChangeMandantConfirm={(event) =>
        handleChangeMandantConfirm(event, formData, setFormData)
      }
      handleTrimValue={(event) => handleTrimValue(event, setFormData)}
      inputFocus={() => inputFocus(page)}
      professional={professional}
      setProfessional={setProfessional}
      professionals={professionals}
      setProfessionals={setProfessionals}
      proprietaireIndivision={proprietaireIndivision}
      setProprietaireIndivision={setProprietaireIndivision}
      proprietairesIndivision={proprietairesIndivision}
      setProprietairesIndivision={setProprietairesIndivision}
      ville={ville}
      CP={CP}
      page={page}
    />,
    <Validation
      formData={formData}
      setFormData={setFormData}
      handleChange={(event) => handleChange(event, setFormData, formData)}
      handleChangeMandataireConfirm={(event) =>
        handleChangeMandataireConfirm(event, setFormData, formData)
      }
      handleChangeMandantConfirm={(event) =>
        handleChangeMandantConfirm(event, formData, setFormData)
      }
      handleChangeFiles={(event) =>
        handleChangeFiles(
          event,
          x_id_submit,
          TypeForm,
          ville,
          filesTest,
          formData,
          setFormData,
          getBase64,
          urlAPI,
          setLoading,
          toast
        )
      }
      handleResetInputFiles={(event) =>
        handleResetInputFiles(
          event,
          x_id_submit,
          TypeForm,
          ville,
          urlAPI,
          formData,
          setFormData
        )
      }
      handleResetFiles={() =>
        handleResetFiles(
          x_id_submit,
          TypeForm,
          ville,
          urlAPI,
          files,
          setFormData,
          formData
        )
      }
      handleSignatureEnd={() =>
        handleSignatureEnd(
          setSignature,
          formData,
          setFormData,
          signature,
          sigRef
        )
      }
      clearSignature={() =>
        clearSignature(sigRef, setSignature, formData, setFormData)
      }
      sigRef={sigRef}
      inputFocus={() => inputFocus(page)}
      professional={professional}
      setProfessional={setProfessional}
      professionals={professionals}
      setProfessionals={setProfessionals}
      proprietaireIndivision={proprietaireIndivision}
      setProprietaireIndivision={setProprietaireIndivision}
      proprietairesIndivision={proprietairesIndivision}
      setProprietairesIndivision={setProprietairesIndivision}
      signature={signature}
      setSignature={setSignature}
      tooltip={tooltip}
      CP={CP}
      page={page}
      ville={ville}
      loading={loading}
    />,
    <Verification
      formData={formData}
      setFormData={setFormData}
      handleChange={(event) => handleChange(event, setFormData, formData)}
      handleChangeMandataireConfirm={(event) =>
        handleChangeMandataireConfirm(event, setFormData, formData)
      }
      handleChangeMandantConfirm={(event) =>
        handleChangeMandantConfirm(event, formData, setFormData)
      }
      handleSignatureEnd={() =>
        handleSignatureEnd(
          setSignature,
          formData,
          setFormData,
          signature,
          sigRef
        )
      }
      clearSignature={() =>
        clearSignature(sigRef, setSignature, formData, setFormData)
      }
      sigRef={sigRef}
      inputFocus={() => inputFocus(page)}
      professional={professional}
      setProfessional={setProfessional}
      professionals={professionals}
      setProfessionals={setProfessionals}
      proprietaireIndivision={proprietaireIndivision}
      setProprietaireIndivision={setProprietaireIndivision}
      proprietairesIndivision={proprietairesIndivision}
      setProprietairesIndivision={setProprietairesIndivision}
      signature={signature}
      ville={ville}
      CP={CP}
      tooltip={tooltip}
      page={page}
    />,
    <TransmissionCU />,
  ];

  return componentList;
};

export default ComponentList;
